import { HttpContext } from "@angular/common/http";
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { Observable } from "rxjs";
import { pathParamsHelper } from "../helpers/path-params.helper";
import { DefaultProduct } from "../pia-api/generated";
import { PiaProductsService } from "../pia-api/pia-products.service";
import { IS_IN_RESOLVER_CONTEXT } from "../tokens/resolver-context.token";
import { withLoading } from "../utils/with-loading";

/**
 * used to get the list of products which are descendants of the currently open product range/ series
 * @param route
 */
export const productDescendantsResolver: ResolveFn<
  Observable<DefaultProduct[]>
> = withLoading(
  (route: ActivatedRouteSnapshot): Observable<DefaultProduct[]> => {
    const piaProductsService = inject(PiaProductsService);
    const { productID, countryID, languageID, year } = pathParamsHelper(route);
    const context = new HttpContext().set(IS_IN_RESOLVER_CONTEXT, true);

    return piaProductsService.getProductDescendantsByProductID(
      { countryID, languageID, productID, year },
      context,
    );
  },
);
